module.exports = __webpack_public_path__ + "resources/icon_50_left_arrow.7ca2c6fef75e39ef.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/offline-dialog/img/icon_50_left_arrow.png
// module id = 592
// module chunks = 0 1 2 3